var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link",class:{ 'active show': _vm.customizer == 'settings' },attrs:{"id":"c-pills-home-tab","href":"javascript:void(0)"},on:{"click":function($event){return _vm.openCustomizerSetting('settings')}}},[_vm._m(0),_c('span',[_vm._v("Quick option")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings"},[_c('i',{staticClass:"icon-settings"})])
}]

export { render, staticRenderFns }